'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.hasKey = hasKey;
exports.getValues = getValues;
exports.getKeys = getKeys;
exports.isHash = isHash;
exports.isArray = isArray;
exports.isString = isString;
exports.isFunction = isFunction;
function hasValue(obj, v) {
  return getValues(obj).indexOf(v) != -1;
};

function hasKey(obj, k) {
  return getKeys(obj).indexOf(k) != -1;
};

function getValues(obj) {
  return getKeys(obj).map(function (k) {
    return obj[k];
  });
};

function getKeys(obj) {
  return Object.keys(obj);
};

function isHash(obj) {
  return obj.__proto__ === Object.prototype;
}

function isArray(arr) {
  return arr instanceof Array;
}

function isString(str) {
  return typeof str == 'string';
}

function isFunction(fn) {
  return typeof fn == 'function';
}
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/dist/utils.js
// module id = 626
// module chunks = 0